import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import FroalaEditor from 'froala-editor';
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/languages/en_gb';
import 'froala-editor/js/languages/de';
import 'froala-editor/js/languages/fr';
import 'froala-editor/js/languages/es';
import 'froala-editor/js/languages/it';
import 'froala-editor/js/languages/pl';
import 'froala-editor/js/languages/ro';
import 'froala-editor/js/languages/cs';
import 'froala-editor/js/languages/nl';
import 'froala-editor/js/languages/tr';
import 'froala-editor/js/languages/uk';
import 'froala-editor/js/languages/sk';
import 'froala-editor/js/languages/hu';
// @ts-ignore
import { loadFontweightPlugin } from 'assets/js/froala-plugins/fontweight.plugin';
// @ts-ignore
import { loadAccordionPlugin } from 'assets/js/froala-plugins/accordion.plugin';
// @ts-ignore
import { loadTemplatesPlugin } from 'assets/js/froala-plugins/templates.plugin';
// @ts-ignore
import { loadFixPasteBug } from 'assets/js/froala-plugins/fix-paste-bug.plugin.js';

import { AppModule } from './app/app.module';
import { environment } from '@environment';
import { getDefaultFroalaEditorConfig } from '@shared/text-editor/froala-config.constants';
import { FroalaCommonService } from '@app/core/services/froala-common.service';

declare global {
  interface Window {
    FroalaEditor: any;
    getDefaultFroalaEditorConfig: any;
  }
}

window.FroalaEditor = FroalaEditor;
window.getDefaultFroalaEditorConfig = getDefaultFroalaEditorConfig;
loadFontweightPlugin();
loadAccordionPlugin();
loadTemplatesPlugin();
loadFixPasteBug();

// @ts-ignore
Object.assign(FroalaEditor.LANGUAGE['de'].translation, {
  Words: 'Wörter', // Workaround the Word counter words not having a de translation
});

// @ts-ignore
Object.assign(FroalaEditor.LANGUAGE['uk'].translation, {
  Words: 'Слова', // Workaround the Word counter words not having a uk translation
});

// @ts-ignore
Object.assign(FroalaEditor.LANGUAGE['tr'].translation, {
  Words: 'Kelimeler', // Workaround the Word counter words not having a tr translation
});

// @ts-ignore
Object.assign(FroalaEditor.LANGUAGE['sk'].translation, {
  Words: 'Slová', // Workaround the Word counter words not having a sk translation
});

// Map 'cz' to 'cs' for Froala (app uses 'cz', Froala uses ISO 'cs')
// @ts-ignore
FroalaEditor.LANGUAGE['cz'] = FroalaEditor.LANGUAGE['cs'];

// Froala doesn't ship a Bulgarian translation, fall back to English so the editor UI still loads
// @ts-ignore
FroalaEditor.LANGUAGE['bg'] = FroalaEditor.LANGUAGE['en_gb'];

const initUsetiful = (): void => {
  const a = document.getElementsByTagName('head')[0];
  const r = document.createElement('script');
  r.async = true;
  r.src = 'https://www.usetiful.com/dist/usetiful.js';
  r.setAttribute('id', 'usetifulScript');
  r.dataset.token = 'e0b72ec859bee9a9dce8957265df4df1';
  a.appendChild(r);
};

if (environment.production) {
  enableProdMode();

  if (environment.development) {
    initUsetiful();
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { ngZone: 'zone.js' })
  .then(appRef => {
    const injector = appRef.injector;
    const froalaCommonServiceInstance = injector.get(FroalaCommonService);
    (window as any).froalaSetupEvents = (editor: any) =>
      froalaCommonServiceInstance.setupEvents(editor);
  })
  .catch(err => console.error(err));
